'use strict';

module.exports = function(options) {
	const isAnonymousUser = !options.user;
	return isAnonymousUser;
};
